module.exports = __webpack_public_path__ + "img/icon-favorite-light.05122c0b.svg";